<template>
  <el-row class="search">
    <el-col :span="16">
      <el-radio-group v-model="type" @change="typeChange">
        <el-radio-button label="week">本周</el-radio-button>
        <el-radio-button label="month">本月</el-radio-button>
        <el-radio-button label="year">全年</el-radio-button>
      </el-radio-group>
      <el-date-picker
        v-model="range"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width:260px;margin-left:16px;"
        @change="dateChange"
      >
      </el-date-picker>
    </el-col>
  </el-row>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      showType: 'preview',
      type: 'month',
      range: [],
      date: []
    }
  },
  methods: {
    typeChange(type) {
      this.range = []
      let date = moment()
      this.$emit(
        'date-change',
        date.startOf(type).format('YYYY-MM-DD'),
        moment()
          .add(1, 'days')
          .format('YYYY-MM-DD')
      )
    },
    dateChange([begin, end]) {
      this.type = ''
      this.$emit(
        'date-change',
        moment(begin).format('YYYY-MM-DD'),
        moment(end).format('YYYY-MM-DD')
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  margin-bottom: 24px;
}
</style>
